/* =========================================================
	SEARCH
========================================================= */
const searchBtn = document.querySelector('.search-open');
const searchForm = document.querySelector('.search-form');
const closeForm = document.querySelector('.close-search');
const formField = document.querySelector('.nav-search');

if (searchBtn !== null) {
	// Open the search form
	searchBtn.addEventListener('click', () => {
		// console.log('open');
		searchForm.classList.toggle('is-visible');
		searchBtn.classList.toggle('is-visible');
		formField.focus()
	});

	// Close the search form
	// closeForm.addEventListener('click', () => {
	// 	searchForm.classList.remove('is-visible');
	// });
}



// var button = document.querySelector('.button');
// var el = document.querySelector('.element');

// button.addEventListener('click', function(e) {
// 	el.classList.toggle('classname');
// });
